<div class="modal-content">
  <div class="modal-header">
    <h4 class="modal-title">
      <i class="fas fa-file-invoice"></i>
      {{ (designTemplate ? "BUTTON.DESIGN-TEMPLATE" : "BUTTON.UPLOAD-TEMPLATE") | translate }}
    </h4>
    <label class="float-right" *ngIf="designTemplate">
      <a class="mr-2 font-styles" href="javascript:"
         (click)="viewParams()"> <i class="fas fa-eye"></i>
        {{ "BUTTON.VIEW-NECESSARY-INFO-TO-TEMPLATE-DESIGN" | translate }}</a>
    </label>
    <button type="button" class="close" aria-label="Close" (click)="activeModal.dismiss('Cross click')"
            *ngIf="!designTemplate">
      <span aria-hidden="true">&times;</span>
    </button>
  </div>
  <div class="modal-body ">
    <div class="row">
      <div class="{{designTemplate ? 'col-md-3':'col-md-5' }}" *ngIf="hasRole(ROLE_SUPERADMIN)">
        <label for="partner" class="font-weight-bold">{{ "LABEL.PARTNER" | translate }}:</label>
        <div class="input-group">
          <div class="input-group-prepend">
            <div class="input-group-text"><i class="fas fa-university"></i></div>
          </div>
          <select class="form-control"
                  [(ngModel)]="partnerIdSelected"
                  (ngModelChange)="reloadEnterprise(partnerIdSelected)"
                  id="partner">
            <option *ngFor="let partner of partners" [ngValue]="partner.id">{{partner.name | translate}}</option>
          </select>
        </div>
      </div>
      <div class="{{designTemplate ? 'col-md-3':'col-md-4' }}"
           *ngIf="hasRole(ROLE_SUPERADMIN) || hasRole(ROLE_PARTNER)">
        <label for="enterprise" class="custom-label-1 font-weight-bold">
          {{ "LABEL.ENTERPRISE" | translate }}:</label>
        <div class="input-group">
          <div class="input-group-prepend">
            <div class="input-group-text"><i class="fas fa-building"></i></div>
          </div>
          <select class="form-control"
                  [(ngModel)]="enterpriseIdSelected"
                  id="enterprise">
            <option *ngFor="let enterprise of enterprises"
                    [ngValue]="enterprise.id">{{enterprise.name | translate}}</option>
          </select>
        </div>
      </div>
      <div [formGroup]="templateForm" class="{{designTemplate ? 'col-md-6': 'col-md-5'}}" *ngIf="designTemplate">
        <label for="templateName1" class="custom-label-1">{{"LABEL.TEMPLATE-NAME" | translate}}: </label>
        <div class="input-group">
          <div class="input-group-prepend">
            <div class="input-group-text"><i class="fas fa-keyboard"></i></div>
          </div>
          <input
            class="form-control {{hasRole(ROLE_SUPERADMIN) || hasRole(ROLE_PARTNER) ? 'max-width-507': 'max-width-602'}}"
            id="templateName1" formControlName="description" [(ngModel)]="template.description"
            placeholder="{{ 'MESSAGE.ENTER-TEMPLATE-NAME' | translate}}">
        </div>
        <small *ngIf="isInvalidControl('description')"
               class="text-danger">
          {{ "MESSAGE.ENTER-TEMPLATE-NAME" | translate }}
        </small>
      </div>
    </div>
    <div class="row" *ngIf="!designTemplate">
      <div class="col-md-5">
        <label for="templateName" class="custom-label-1">{{"LABEL.TEMPLATE-NAME" | translate}}: </label>
        <div class="input-group">
          <div class="input-group-prepend">
            <div class="input-group-text"><i class="fas fa-keyboard"></i></div>
          </div>
          <input class="form-control max-width-305" id="templateName"
                 [(ngModel)]="template.description"
                 placeholder="{{ 'MESSAGE.ENTER-TEMPLATE-NAME' | translate}}">
        </div>
      </div>
      <div class="col-md-4">
        <label class="custom-label-1">{{"LABEL.SELECT-TEMPLATE" | translate}}:
          <div class="custom-file content-file">
            <input type="file" class="custom-file-input w-100 content-file" accept="application/pdf"
                   id="customFile" (change)="changeStatus($event)">
            <label class="custom-file-label"
                   for="customFile">
              {{ this.selectedFile ? selectedFile.name : "MESSAGE.SELECT" | translate }}
            </label>
          </div>
        </label>
      </div>
      <div class="col-md-3 mt-4">
        <div class="progress form-group mt-2">
          <div class="progress-bar progress-bar-striped bg-success" role="progressbar"
               [style.width.%]="progressUpdate">
          </div>
        </div>
      </div>
      <br>
      <!--      </form>-->
    </div>
    <div class="row mt-2" *ngIf="designTemplate">
      <div class="col-md-7">
        <div
          style="border: dotted #ccc 2px; max-width: 605px; min-width: 605px!important;">
          <div class="drag-boundary" id="pdfContainer" #pdfContainer>
            <div class="drag-box custom-box" cdkDragBoundary=".drag-boundary"
                 *ngFor="let element of elements; let index = index"
                 cdkDrag style="{{getStyleTransform(element, index)}}"
                 (cdkDragEnded)="dragEnded($event, element)">
              <i class="fa fa-times-circle btn-delete-float" (click)="deleteItem(index)"></i>
              <ng-container *ngIf="element.type === 3 then TABLE; else OTHERS;">
              </ng-container>
              <ng-template #OTHERS>
                <div id="resize" (click)="selectedItem(element.text)" class="limit-content">
                  <div class="text-editor" style="{{getStyleForTag(element)}}"
                       id="text{{index}}"
                       (click)="addProperties(element, index)"
                       [innerHTML]="element.text">
                  </div>
                </div>
              </ng-template>
              <ng-template #TABLE cdkDragBoundary=".drag-boundary" cdkDrag>
                <div id="tableElement{{index}}" class="tableElement"
                     (click)="selectedItem(element.text)">
                  <div class="hidden-content">
                    <button class="btn btn-outline-dark btn-float" (click)="addRow(element)">
                      + {{"BUTTON.ROW" | translate}}
                    </button>
                    <button class="btn btn-outline-dark btn-float" (click)="addColumn(element)">
                      + {{"BUTTON.COLUMN" | translate}}
                    </button>
                    <button class="btn btn-outline-dark btn-float" (click)="deleteRows(element)">x
                      {{"BUTTON.ROW" | translate}}
                    </button>
                    <button class="btn btn-outline-dark btn-float" (click)="deleteColumns(element, index)">x
                      {{"BUTTON.COLUMN" | translate}}
                    </button>
                  </div>
                  <table id="table{{index}}" class="table" cdkDragBoundary=".drag-boundary" cdkScrollable>
                    <thead id="thead{{index}}">
                    <tr>
                      <th *ngFor="let column of element.columns; let indexColumn = index"
                          id="th{{index}}{{indexColumn}}" class="cursor-pointer"
                          (click)="addFontProperties(element, index, TH, indexColumn)" contenteditable="true">
                        <span [innerHTML]="column.colName"></span>
                      </th>
                    </tr>
                    </thead>
                    <tbody id="tbody{{index}}">
                    <tr *ngFor="let row of element.rows; let indexRow = index"
                        (click)="selectElement(indexRow)"
                        id="tr{{indexRow}}">
                      <td *ngFor="let cell of row.cells; let indexCell = index"
                          id="td{{index}}{{indexRow}}{{indexCell}}" class="cursor-pointer"
                          (click)="addFontProperties(element, index, TD,0, indexRow, indexCell)"
                          contenteditable="true"><span
                        [innerHTML]="cell.cellName"></span></td>
                    </tr>
                    </tbody>
                  </table>
                  <a [innerHTML]="element.text" [hidden]="true"></a>
                  <div (click)="addProperties(element,index,'table')" class="hidden-content cursor-pointer">
                    <a style="color: gray">{{"LABEL.CLICK-HERE-SELECT-TABLE" | translate}}</a>
                  </div>
                </div>
              </ng-template>
            </div>
          </div>
        </div>
      </div>
      <div class="col-md-5" style="margin-left: -30px;">
        <div class="custom-div">
          <label class="custom-label modal-title"><h3>
            <span class="fas fa-palette"></span> {{"PALETTE.DESCRIPTION"| translate}}</h3></label>
          <hr class="mt">
          <span class="col cursor-pointer"
                (click)="addElement(IMAGE_TYPE, NONE, this.elements.length)"><i
            class="fa fa-image"></i> {{"PALETTE.IMAGE"| translate}}</span>
          <span class="col cursor-pointer"
                (click)="addElement(TABLE_TYPE, NONE)"><i
            class="fa fa-table"></i> {{"PALETTE.TABLE"| translate}}</span>
          <span class="col cursor-pointer"
                (click)="addElement(TEXT_TYPE, TEXT_DESCRIPTION )">
                <i class="fa fa-text-width"></i> {{"PALETTE.TEXT"| translate}}</span>
          <span class="col cursor-pointer"
                (click)="addElement(PARAM_TYPE, PARAM_DESCRIPTION )">
                <i class="fa fa-paragraph"
                   aria-hidden="true"></i> {{"PALETTE.PARAMETER"| translate}}</span>
          <br>
        </div>
        <app-add-image-property *ngIf="selectImageItem"
                                [imageProperty]="imageProperty"
                                (saveImage)="applyImageProperty($event)">
          <!--          [events]="eventsSubjectProperties.asObservable()"-->
        </app-add-image-property>
        <app-add-font-property *ngIf="selectFontItem"
                               [fontProperty]="fontProperty"
                               [element]="elementSelected"
                               (saveFontProperty)="applyFontProperty($event)">
        </app-add-font-property>
        <app-add-table-property *ngIf="selectTableItem"
                                [tableProperty]="tableProperty"
                                [element]="elementSelected"
                                (saveTableProperty)="applyTableProperty($event)">
        </app-add-table-property>
      </div>
    </div>
  </div>
</div>
<div *ngIf="isIofe" class="col">
  <div class="custom-control custom-checkbox ml-2">
    <input type="checkbox"
           id="showAllCheckbox"
           class="custom-control-input"
           [(ngModel)]="showAll"
           (click)="onlyShowAll($event)">
    <label class="custom-control-label"
           for="showAllCheckbox">{{ "LABEL.SHOW-DEFAULT-TEMPLATES" | translate }}</label>
  </div>
</div>
<div class="modal-footer">
  <button type="button" class="btn btn-outline-success"
          (click)="save()" *ngIf="designTemplate">
    <i class="fa fa-bookmark"></i> {{"BUTTON.SAVE"  | translate }}
  </button>

  <button type="button" class="btn btn-outline-success"
          (click)="upload()" *ngIf="!designTemplate">
    <i class="fas fa-upload"></i> {{ "BUTTON.UPLOAD" | translate }}
  </button>

  <div *ngIf="designTemplate">
    <button type="button" class="btn btn-outline-info"
            (click)="preview('preview')">
      <span class="fa fa-eye"></span> {{ "BUTTON.PREVIEW" | translate }}
    </button>
  </div>
  <button type="button" class="btn btn-outline-danger"
          (click)="cancel()">
    <span class="{{designTemplate ? 'fa fa-times-circle': ''}}"></span>
    {{ (designTemplate ? "BUTTON.CANCEL" : "BUTTON.ACCEPT") | translate }}
  </button>
</div>
<app-loading *ngIf="loading"></app-loading>
